import loadable from "@loadable/component";
import { PATH } from "contants/path";

const InfoLoyaltyProgramPage = loadable(
  () => import("pages/InfoPage/InfoLoyaltyPage")
);
const LightningDiceLive = loadable(
  () => import("pages/InfoPage/LightningDiceLivePage")
);

const AboutUsPage = loadable(() => import("pages/InfoPage/AboutUsPage"));

const AndarBaharLivePage = loadable(
  () => import("pages/InfoPage/AndarBaharLivePage")
);
const BlackjackLivePage = loadable(
  () => import("pages/InfoPage/BlackjackLivePage")
);
const CrazyTimeLivePage = loadable(
  () => import("pages/InfoPage/CrazyTimeLivePage")
);
const DragonTigerLivePage = loadable(
  () => import("pages/InfoPage/DragonTigerLivePage")
);
const LightningRouletteLivePage = loadable(
  () => import("pages/InfoPage/LightningRouletteLivePage")
);
const TeenPattiLivePage = loadable(
  () => import("pages/InfoPage/TeenPattiLivePage")
);
const InstaPromoCodePage = loadable(
  () => import("pages/InfoPage/InstaPromoCodePage")
);
const MultipleBonusPage = loadable(
  () => import("pages/InfoPage/MultipleBonusPage")
);
const SportsCashbackPage = loadable(
  () => import("pages/InfoPage/SportsCashbackPage")
);

const BettingRulesPage = loadable(
  () => import("pages/InfoPage/BettingRulesPage")
);
const ChangeAccountsPage = loadable(
  () => import("pages/InfoPage/ChangeAccountsPage")
);
const ContactUsPage = loadable(() => import("pages/InfoPage/ContactUsPage"));
const FaqPage = loadable(() => import("pages/InfoPage/FaqPage"));
const KYCPage = loadable(() => import("pages/InfoPage/KYCPage"));
const PrivacyPage = loadable(() => import("pages/InfoPage/PrivacyPage"));
const ResponsibleGamingPage = loadable(
  () => import("pages/InfoPage/ResponsibleGamingPage")
);
const SelfExclusionPolicyPage = loadable(
  () => import("pages/InfoPage/SelfExclusionPolicyPage")
);
const TermsPage = loadable(() => import("pages/InfoPage/TermsPage"));

const GrowpayPage = loadable(() => import("pages/InfoPage/GrowpayPage"));
const CasinoChooseGamePage = loadable(
  () => import("pages/InfoPage/CasinoChooseGamePage")
);
const WagerPage = loadable(() => import("pages/InfoPage/WagerPage"));
const DepositInstructionPage = loadable(
  () => import("pages/InfoPage/DepositInstructionsPage")
);
const PaymentsAndWithdrawalMethods = loadable(
  () => import("pages/InfoPage/PaymentsWithdrawalPage")
);
const UPIPage = loadable(() => import("pages/InfoPage/UPIPage"));
const UPIRegistrationPage = loadable(
  () => import("pages/InfoPage/UPIRegistrationPage")
);
const WithdrawalInstructionsPage = loadable(
  () => import("pages/InfoPage/WithdrawalInstructionsPage")
);
const FreeBetsPage = loadable(() => import("pages/InfoPage/FreeBetsPage"));
const PromoCodesPage = loadable(() => import("pages/InfoPage/PromoCodesPage"));
const AndroidAppPage = loadable(() => import("pages/InfoPage/AndroidAppPage"));

const Blog = loadable(() => import("pages/Blog"));
const BlogContentDetails = loadable(
  () => import("pages/Blog/BlogContentDetails")
);

export const footerRouter = {
  children: [
    {
      path: PATH.info.wager,
      element: <WagerPage />,
    },
    {
      path: PATH.info.wager,
      element: <WagerPage />,
    },
    {
      path: PATH.info.growpay,
      element: <GrowpayPage />,
    },
    {
      path: PATH.info.infoLoyaltyProgram,
      element: <InfoLoyaltyProgramPage />,
    },
    {
      path: PATH.info.upi,
      element: <UPIPage />,
    },
    {
      path: PATH.info.upiRegistration,
      element: <UPIRegistrationPage />,
    },
    {
      path: PATH.info.depositInstructions,
      element: <DepositInstructionPage />,
    },

    {
      path: PATH.info.withdrawalInstructions,
      element: <WithdrawalInstructionsPage />,
    },
    {
      path: PATH.info.howToChoose,
      element: <CasinoChooseGamePage />,
    },
    {
      path: PATH.info.paymentWithdrawalMethods,
      element: <PaymentsAndWithdrawalMethods />,
    },
    {
      path: PATH.info.freeBets,
      element: <FreeBetsPage />,
    },
    {
      path: PATH.info.promoCodes,
      element: <PromoCodesPage />,
    },
    {
      path: PATH.info.androidApp,
      element: <AndroidAppPage />,
    },
    {
      path: PATH.info.changeAccount,
      element: <ChangeAccountsPage />,
    },
    {
      path: PATH.info.about,
      element: <AboutUsPage />,
    },
    {
      path: PATH.info.terms,
      element: <TermsPage />,
    },
    {
      path: PATH.info.responsibleGaming,
      element: <ResponsibleGamingPage />,
    },
    {
      path: PATH.info.selfExclusionPolicy,
      element: <SelfExclusionPolicyPage />,
    },
    {
      path: PATH.info.kyc,
      element: <KYCPage />,
    },
    {
      path: PATH.info.bettingRules,
      element: <BettingRulesPage />,
    },
    {
      path: PATH.info.privacy,
      element: <PrivacyPage />,
    },
    {
      path: PATH.info.contactUs,
      element: <ContactUsPage />,
    },
    {
      path: PATH.info.faq,
      element: <FaqPage />,
    },
    {
      path: PATH.info.instaPromoCode,
      element: <InstaPromoCodePage />,
    },
    {
      path: PATH.info.sportsCashback,
      element: <SportsCashbackPage />,
    },
    {
      path: PATH.info.multipleBonus,
      element: <MultipleBonusPage />,
    },
    {
      path: PATH.info.teenPattiLive,
      element: <TeenPattiLivePage />,
    },
    {
      path: PATH.info.dragonTigerLive,
      element: <DragonTigerLivePage />,
    },
    {
      path: PATH.info.crazyTimeLine,
      element: <CrazyTimeLivePage />,
    },
    {
      path: PATH.info.lightningDiceLive,
      element: <LightningDiceLive />,
    },
    {
      path: PATH.info.blackJackLive,
      element: <BlackjackLivePage />,
    },
    {
      path: PATH.info.lightningRouletteLive,
      element: <LightningRouletteLivePage />,
    },
    {
      path: PATH.info.andarBabarLive,
      element: <AndarBaharLivePage />,
    },
    {
      path: PATH.info.blog,
      element: <Blog />,
    },
    {
      path: PATH.info.blogDetail,
      element: <BlogContentDetails />,
    },
  ],
};
